import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Landmark, CheckCircle2 } from "lucide-react";

export const AdminTransferenciasTab = () => {
  const [ordenes, setOrdenes] = useState([]);
  const load = () => api.get("/ordenes/transferencias-pendientes").then(r => setOrdenes(r.data.ordenes)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, []);

  const confirmar = async (id) => {
    try {
      await api.patch(`/ordenes/${id}/confirmar-transferencia`);
      toast.success("Transferencia confirmada · comercios notificados");
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div>
      <div className="bg-zinc-900 text-white rounded-sm p-5 flex items-center gap-4">
        <Landmark className="w-6 h-6 text-[#D4FF00]" />
        <div>
          <div className="font-display font-bold">Cuenta receptora · Marketing de Inteligencia Artificial S de RL de CV</div>
          <div className="text-xs text-white/60 font-mono mt-0.5">BBVA · CLABE 012320001130928363</div>
        </div>
      </div>
      <div className="overline text-zinc-500 mt-6 mb-3">Transferencias por confirmar ({ordenes.length})</div>
      {ordenes.length === 0 ? (
        <div className="border border-dashed border-zinc-300 rounded-sm p-10 text-center text-zinc-400 text-sm">Sin transferencias pendientes</div>
      ) : (
        <div className="grid gap-3">
          {ordenes.map(o => (
            <div key={o.id} data-testid={`transfer-${o.id}`} className="bg-white border border-zinc-200 rounded-sm p-4 flex flex-wrap items-center gap-4">
              <div className="font-mono font-black text-xl">{o.token_seguridad}</div>
              <div className="text-sm">
                <div className="font-medium">{o.cliente_nombre} · {o.cliente_telefono || "sin tel."}</div>
                <div className="text-xs text-zinc-500">{new Date(o.created_at).toLocaleString()} · {o.detalles.length} artículos · envío {o.metodo_envio}</div>
              </div>
              <Badge className="bg-amber-100 text-amber-700 border-0">Pendiente</Badge>
              <div className="ml-auto font-display font-black text-xl">${o.total.toFixed(2)}</div>
              <Button size="sm" data-testid={`confirm-transfer-${o.id}`} onClick={() => confirmar(o.id)} className="rounded-sm bg-emerald-500 hover:bg-emerald-600">
                <CheckCircle2 className="w-4 h-4 mr-1" /> Confirmar pago
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
